import { Component, HostBinding } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreService } from './core.service';

import { HeaderComponent } from './header/header.component';
import { TvboxComponent } from './tvbox/tvbox.component';
import { ChatComponent } from './chat/chat.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { FooterComponent } from './footer/footer.component';

import { SettingsService } from './settings/settings.service';
import { ProfileService } from './profile/profile.service';

@Component({
	selector: 'app-root',
	imports: [
		HeaderComponent,
		TvboxComponent,
		ChatComponent,
		ScheduleComponent,
		FooterComponent,

		RouterOutlet,
		CommonModule
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {

	constructor(
		public core: CoreService,
		public settings: SettingsService,
		public profile: ProfileService,
	){}

	@HostBinding('class.layout-default') get is_default(){
		return !this.settings.use_layout_theater
	}

	@HostBinding('class.layout-theater') get is_theater(){
		return this.settings.use_layout_theater
	}

	@HostBinding('class.layout-pinned') get is_pinned(){ return false }

	ngOnInit(){

		setInterval( ()=>{ this.core.stateshot_sync(); }, 45000 );

		if( this.profile.is_premium ){

			//PreLoad the chromecast stuff if they are premium.
			this.core.load_scripts("https://www.gstatic.com/cv/js/sender/v1/cast_sender.js").subscribe(()=>{});

			this.profile.maintain_premium_sig();
			if( this.profile.is_premium ){
				setInterval( ()=>{this.profile.premium_softcheck()}, 1000 * 60 * 5 )
				setTimeout(  ()=>{this.profile.premium_softcheck()}, 1000 * 30 )
			}
		}

		document.fonts.ready.then(()=>{
			document.body.classList.remove('material-loading');
		});
		setTimeout(()=>{
			document.body.classList.remove('material-loading');
		}, 5000);

	}

}
